import React, { useRef, useState } from 'react';
import Slider from 'react-slick';

const Features = () => {
    const sliderRef = useRef(null);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [centerIndex, setCenterIndex] = useState(0);

    const next = () => {
        sliderRef.current.slickNext();
    };

    const previous = () => {
        sliderRef.current.slickPrev();
    };

    const handleBeforeChange = (oldIndex, newIndex) => {
        setCenterIndex(newIndex);
    };

    const handleAfterChange = (current) => {
        setCurrentIndex(current);
    };

    const settings = {

        centerMode: true,
        infinite: true,
        centerPadding: "0px",
        slidesToShow: 3,
        speed: 800,
        beforeChange: handleBeforeChange,
        afterChange: handleAfterChange,
        responsive: [
            {
                breakpoint: 1279,
                settings: {
                    slidesToShow: 1,
                },
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    };

    const carousles = [
        { name: "Swimming Pool", image: "https://greendirectorydata.s3.us-east-2.amazonaws.com/am6.jpg" },
        { name: "Kids Pool", image: "https://greendirectorydata.s3.us-east-2.amazonaws.com/am7.jpg" },
        { name: "GYM", image: "https://greendirectorydata.s3.us-east-2.amazonaws.com/am1.jpg" },
        { name: "Lobby", image: "https://greendirectorydata.s3.us-east-2.amazonaws.com/am3.jpg" },
    ]
    const handleArrowClick = (direction) => {
        if (direction === "left") {
            previous();
        } else if (direction === "right") {
            next();
        }
    };

    return (
        <div className='feature-main-div'>
            <div className='container'>
                <div className='feature-text-div'>
                    <h4>Features & Amenities</h4>
                </div>
                <div className='container'>
                    <div className='carousels-text-main-div'>
                        <div className='feature-arrow-text-div'>
                            <div className='feature-carousles-text-div'>
                                <h2>{carousles[centerIndex]?.name}</h2>
                            </div>
                            <div className='arrow-div'>
                                <div className='arrow'>
                                    <button onClick={() => handleArrowClick("left")}>
                                        {/* Left Arrow SVG */}
                                        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="12" viewBox="0 0 23 12" fill="none">
                                            <path d="M22 6.75C22.4142 6.75 22.75 6.41421 22.75 6C22.75 5.58579 22.4142 5.25 22 5.25L22 6.75ZM0.469669 5.46967C0.176777 5.76256 0.176777 6.23744 0.46967 6.53033L5.24265 11.3033C5.53554 11.5962 6.01041 11.5962 6.3033 11.3033C6.5962 11.0104 6.5962 10.5355 6.3033 10.2426L2.06066 6L6.3033 1.75736C6.59619 1.46447 6.59619 0.989593 6.3033 0.696699C6.0104 0.403806 5.53553 0.403806 5.24264 0.696699L0.469669 5.46967ZM22 5.25L0.999999 5.25L1 6.75L22 6.75L22 5.25Z" fill="#C8AA8E" />
                                        </svg>
                                    </button>
                                </div>
                                <div className='arrow'>
                                    <button onClick={() => handleArrowClick("right")}>
                                        {/* Right Arrow SVG */}
                                        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="12" viewBox="0 0 23 12" fill="none">
                                            <path d="M1 5.25C0.585786 5.25 0.25 5.58579 0.25 6C0.25 6.41421 0.585787 6.75 1 6.75L1 5.25ZM22.5303 6.53033C22.8232 6.23744 22.8232 5.76257 22.5303 5.46967L17.7574 0.696701C17.4645 0.403807 16.9896 0.403807 16.6967 0.696701C16.4038 0.989594 16.4038 1.46447 16.6967 1.75736L20.9393 6L16.6967 10.2426C16.4038 10.5355 16.4038 11.0104 16.6967 11.3033C16.9896 11.5962 17.4645 11.5962 17.7574 11.3033L22.5303 6.53033ZM1 6.75L22 6.75L22 5.25L1 5.25L1 6.75Z" fill="#C8AA8E" />
                                        </svg>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className='carousels-main-div'>
                            <Slider ref={sliderRef} {...settings}>
                                {carousles.map((slide, index) => (
                                    <div key={index} className="carousles-div">
                                        <div
                                            className={`images-div ${centerIndex === index ? 'active' : ''}`}
                                        >
                                            <img
                                                src={slide.image}
                                                alt="Banner Image"
                                            />
                                        </div>
                                    </div>
                                ))}
                            </Slider>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Features;
